<!-- Loading -->
<div *ngIf="isLoading" class="space-y-2">
  <div *ngFor="let i of [1,2,3]"
    class="bg-white dark:bg-surface-900 rounded-lg p-3 border border-surface-200 dark:border-surface-800">
    <p-skeleton width="100%" height="120px"></p-skeleton>
  </div>
</div>

<!-- Empty State -->
<div *ngIf="!isLoading && tickets.length === 0" class="text-center py-8">
  <div class="bg-surface-50 dark:bg-surface-800 rounded-lg w-12 h-12 flex items-center justify-center mx-auto mb-2">
    <i class="pi pi-ticket text-xl text-surface-400"></i>
  </div>
  <h3 class="text-sm font-medium text-surface-900 dark:text-surface-50 mb-1">
    Keine Tickets
  </h3>
  <p class="text-xs text-surface-500 dark:text-surface-400 mb-3">
    Du hast noch keine Tickets gekauft
  </p>
  <p-button
    label="Zum Shop"
    icon="pi pi-shopping-cart"
    routerLink="/dashboard/regio-shop"
    [outlined]="true"
    size="small">
  </p-button>
</div>

<!-- Tickets List -->
<div *ngIf="!isLoading && tickets.length > 0" class="space-y-3">
  <div *ngFor="let ticket of tickets"
    (click)="viewTicket(ticket)"
    class="bg-white dark:bg-surface-900 rounded-xl p-4 border border-surface-200 dark:border-surface-800 active:bg-surface-50 dark:active:bg-surface-800 transition-colors cursor-pointer">

    <!-- Header: Image + Name -->
    <div class="flex items-center gap-3 mb-3">
      <img *ngIf="ticket.ticketProduct?.product?.imageUrl"
        [src]="ticket.ticketProduct?.product?.imageUrl"
        class="w-14 h-14 rounded-xl object-cover flex-shrink-0" />
      <div *ngIf="!ticket.ticketProduct?.product?.imageUrl"
        class="w-14 h-14 rounded-xl flex items-center justify-center flex-shrink-0"
        [ngClass]="getIconBgClass(ticket.status)">
        <i [class]="getTicketTypeIcon(ticket.ticketProduct?.ticketType) + ' text-xl'"
           [ngClass]="getIconColorClass(ticket.status)"></i>
      </div>
      <div class="flex-1 min-w-0">
        <h4 class="text-base font-semibold text-surface-900 dark:text-surface-50 line-clamp-2 mb-1">
          {{ ticket.ticketProduct?.product?.name || 'Ticket' }}
        </h4>
        <p class="text-sm text-surface-500 dark:text-surface-400">
          {{ ticket.businessHub?.name }}
        </p>
      </div>
    </div>

    <!-- Info Rows -->
    <div class="space-y-2 text-sm">
      <!-- Status -->
      <div class="flex items-center justify-between py-2 border-t border-surface-100 dark:border-surface-800">
        <span class="text-surface-500 dark:text-surface-400">Status</span>
        <p-chip
          [label]="getStatusLabel(ticket.status)"
          [styleClass]="'text-xs px-2 py-0.5 ' + getStatusChipClass(ticket.status)">
        </p-chip>
      </div>

      <!-- Ticket Type -->
      <div class="flex items-center justify-between py-2 border-t border-surface-100 dark:border-surface-800">
        <span class="text-surface-500 dark:text-surface-400">Ticket-Art</span>
        <span class="font-medium text-surface-900 dark:text-surface-50 flex items-center gap-1.5">
          <i [class]="getTicketTypeIcon(ticket.ticketProduct?.ticketType) + ' text-primary-600'"></i>
          {{ getTicketTypeLabel(ticket.ticketProduct?.ticketType) }}
        </span>
      </div>

      <!-- Valid Until -->
      <div *ngIf="ticket.validUntil" class="flex items-center justify-between py-2 border-t border-surface-100 dark:border-surface-800">
        <span class="text-surface-500 dark:text-surface-400">Gültig bis</span>
        <div class="flex flex-col items-end gap-1">
          <span class="font-medium"
            [ngClass]="isExpiringSoon(ticket.validUntil) || isExpired(ticket.validUntil) ? 'text-red-600' : 'text-surface-900 dark:text-surface-50'">
            {{ formatDate(ticket.validUntil) }}
          </span>
          <span *ngIf="getDaysRemaining(ticket.validUntil) !== null"
            class="text-xs px-2 py-0.5 rounded-full font-medium"
            [ngClass]="isExpired(ticket.validUntil) ? 'bg-red-100 text-red-700' :
                       isExpiringSoon(ticket.validUntil) ? 'bg-orange-100 text-orange-700' :
                       'bg-green-100 text-green-700'">
            {{ getRemainingDaysText(ticket.validUntil) }}
          </span>
        </div>
      </div>

      <!-- Purchased At -->
      <div class="flex items-center justify-between py-2 border-t border-surface-100 dark:border-surface-800">
        <span class="text-surface-500 dark:text-surface-400">Gekauft am</span>
        <span class="font-medium text-surface-900 dark:text-surface-50">
          {{ formatDate(ticket.purchasedAt) }}
        </span>
      </div>

      <!-- Usage Progress (for stamp cards) -->
      <div *ngIf="ticket.usesInfo" class="py-2 border-t border-surface-100 dark:border-surface-800">
        <div class="flex justify-between text-sm mb-2">
          <span class="text-surface-500 dark:text-surface-400">Nutzungen</span>
          <span class="font-semibold text-surface-900 dark:text-surface-50">
            {{ ticket.usesInfo.remaining }} / {{ ticket.usesInfo.total }} übrig
          </span>
        </div>
        <div class="w-full h-2.5 bg-surface-200 dark:bg-surface-700 rounded-full overflow-hidden">
          <div class="h-full bg-gradient-to-r from-green-500 to-green-600 rounded-full transition-all"
            [style.width.%]="getUsageProgress(ticket)"></div>
        </div>
      </div>
    </div>

    <!-- Arrow -->
    <div class="flex justify-center mt-3 pt-2 border-t border-surface-100 dark:border-surface-800">
      <span class="text-xs text-surface-400 flex items-center gap-1">
        Details anzeigen
        <i class="pi pi-chevron-right"></i>
      </span>
    </div>
  </div>
</div>
